module.exports = __webpack_public_path__ + "static/media/ic_upgrade.900dfe08.svg";